import { useSetFilter } from '../../filter';
import { AssetMediaFilterKey } from '../domain';
import { useCurrentWorkspace } from '../../auth';

export const useSetAssetMediaFilter = (assetId: string) => {
  const currentWorkspace = useCurrentWorkspace();
  const workspace = currentWorkspace === null ? 'ME' : currentWorkspace?.id;

  return useSetFilter(
    `${AssetMediaFilterKey}-${assetId}`,
    'assetMediaFilter',
    true,
    workspace ? `${workspace}__${assetId}` : assetId
  );
};
